import React from 'react'
import './VisaInfo.css'
import ImageGallery from './imageGallery 2'
import VisaReq from './VisaReq'
import VisaProc from './VisaProc'
import GeneralInfo from './GeneralInfo'
import UserInsights from './UserInsight'
import TalkToExperts from './talktoexperts'
import OurSources from './OurSources'
import PopularTours from './PopularTours'
import BillPayment from './BillPayment'
import VisaSelection from './VisaSelection'
import FAQ from './FAQ 2'

import c1 from '../assets/Company logo.png'
import c2 from '../assets/Company logo-2.png'
import c3 from '../assets/Company logo-4.png'
import c4 from '../assets/Company logo-5.png'

function VisaInfo() {

  return (
    <div className='visaInfo'>
      <ImageGallery />
      <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}} className='contentarea'> 
        <div className='visainfocontent' >
          <VisaSelection /> 
          <VisaReq />
          <VisaProc />
          <GeneralInfo />
          <UserInsights />
          <FAQ />
          <TalkToExperts />
          <OurSources />
          <div>
            <div className='sectiontitle'>Our <span>Partners</span></div>
            <div style={{display:'flex', justifyContent:'space-between',backgroundColor:'white', padding:'30px',borderRadius:'15px'}}>
              <div>
                <img style={{width:'80%',height:'auto'}} src={c1}></img>
              </div>
              <div>
                <img style={{width:'80%',height:'auto'}}  src={c2}></img>
              </div>
              <div>
                <img style={{width:'80%',height:'auto'}}  src={c3}></img>
              </div>
              <div>
                <img style={{width:'80%',height:'auto'}}  src={c4}></img>
              </div>
            </div>
          </div>
          <PopularTours />
        </div>
        <div style={{position:'sticky',top:'0',width:'40%',padding:'20px',borderRadius:'15px'}}>
          <BillPayment />
        </div>
      </div>
    </div>
  )
}

export default VisaInfo
